export const FEEDBACK_TITLE_TEXT = 'Is this content helpful?';
export const FEEDBACK_MODAL_TITLE = 'Give us feedback and help us improve the product';
export const FEEDBACK_MODAL_DISCLAIMER_TEXT = 'This survey is optional';

export const OPTIONAL_TEXT_TITLE = 'Tell us more?';
export const OPTIONAL_TEXT_LABEL = 'Share feedback or ideas to improve the experience.';
export const OPTIONAL_TEXT_FOOTER = 'Do not include any Personally Identifiable Information.';
